// NOTE: ending g (global) leaves index uncleared for successive calls
const email_pattern = "[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\.[a-z]{2,}$"
const password_pattern = "^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*\\(\\)\\{\\}\\-+:,\\._]){1,}).{8,}$"
const url_pattern = /^((http|https|rtp):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b(:\d+)?\/([-a-zA-Z0-9@:%_+.~#?&\/=]*)$/
// const ip_url_pattern = /^((http|https|rtp):\/\/)(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\/([-a-zA-Z0-9@:%_+.~#?&\/=]*)$/
const ip_url_pattern = /^((http|https|rtp):\/\/)((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?):([0-9]{1,5})\/([-a-zA-Z0-9@:%_+.~#?&\/=]*)$/
const server_pattern = new RegExp("^[a-z0-9.-]+\\.[a-z]{2,}$")
const ip_server_pattern = new RegExp("(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])")
const ntp_pattern = /^(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}|localhost|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|[0-9a-fA-F]{1,4}::[0-9a-fA-F]{1,4}))$/gm


export const regex =
    {
        email_pattern,
        password_pattern,
        url_pattern,
        ip_url_pattern,
        server_pattern,
        ip_server_pattern,
        ntp_pattern
    }